import React from "react";

import ImageAvatar from "../../../../ui/components/ImageAvatar/ImageAvatar";

export default function DiscussionChannelUserImages({ users }) {
	if (users.length <= 0) {
		return <ImageAvatar src="/img/avatar.png" style={{ height: 40, width: 40 }} />;
	}

	return users?.slice(0, 2).map(({ img }, index, users) => {
		return (
			<ImageAvatar
				src={img}
				key={index}
				style={{
					height: users.length === 1 ? 40 : 30,
					width: users.length === 1 ? 40 : 30,
					marginLeft: index === 0 ? 0 : -30,
					marginTop: users.length > 1 && (index === 0 ? -10 : 10),
					border: "2px solid #fff",
				}}
			/>
		);
	});
}
